import { createSlice } from '@reduxjs/toolkit'

const initialState= { 
  open: false,
  message: "",
  type: undefined,
  code: null
}

const modalSlice = createSlice({
  name: 'modal',
  initialState,
  reducers: {
    openModal: (state, action)=>{
      state.open = true;
      state.message = action.payload.message || "Ocorreu um erro inesperado. Por favor, contate o administrador.";
      state.type = action.payload.type || "error"
    state.code = action.payload.code
    },
    closeModal: (state)=>initialState
  },
})

export const {openModal, closeModal} = modalSlice.actions

export default modalSlice.reducer
